<template>
  <article>
    <div>
      <span class="xbed-sub-title">菜单管理</span>
    </div>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>微信</BreadcrumbItem>
        <BreadcrumbItem>菜单管理</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <section style="margin-top:20px">
      <Form inline>
        <FormItem>
          <Button type="primary" @click="addMenuBtn">新增菜单</Button>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="generateMenu">生成菜单</Button>
        </FormItem>
      </Form>
      <Table stripe :columns="columns" :data="menuList"></Table>
    </section>
    <Modal :title="modalConfig.title" :loading="true" v-model="modalConfig.display" @on-ok="modalBtn" ref="modal">
      <Form :label-width="100" :model="modalConfig.data" ref="modalForm">
        <FormItem label="菜单ID" v-if="modalConfig.data.menuId">
          <Input disabled v-model="modalConfig.data.menuId"></Input>
        </FormItem>
        <FormItem label="菜单名称">
          <Input v-model="modalConfig.data.name"></Input>
        </FormItem>
        <FormItem label="父级菜单">
          <Select clearable v-model="modalConfig.data.parentId">
            <Option v-for="item in parentMenuList" :key="item.menuId" :value="item.menuId">{{item.name}}</Option>
          </Select>
        </FormItem>
        <FormItem label="菜单类型">
          <Select v-model="modalConfig.data.type">
            <Option value="view">view类型</Option>
            <Option value="click">click类型</Option>
            <Option value="miniprogram">miniprogram</Option>
          </Select>
        </FormItem>
        <FormItem label="关键字" v-if="modalConfig.data.type==='click'">
          <Input v-model="modalConfig.data.keyword" :maxLength="30"></Input>
        </FormItem>
        <FormItem label="链接" v-if="modalConfig.data.type==='view'">
          <Input v-model="modalConfig.data.url"></Input>
        </FormItem>
        <FormItem label="是否为外链" v-if="modalConfig.data.type==='view'">
          <RadioGroup v-model="modalConfig.data.isExtUrl">
            <Radio :label="1">是</Radio>
            <Radio :label="0">否</Radio>
            <span class="tips">内部链接时，会带加入weixin的认证，取得openid</span>
          </RadioGroup>
        </FormItem>
        <FormItem label="appid" v-if="modalConfig.data.type==='miniprogram'">
          <Input v-model="modalConfig.data.appId"></Input>
        </FormItem>
        <FormItem label="页面路径" v-if="modalConfig.data.type==='miniprogram'">
          <Input v-model="modalConfig.data.pagePath"></Input>
        </FormItem>
        <FormItem label="备用链接" v-if="modalConfig.data.type==='miniprogram'">
          <Input v-model="modalConfig.data.url"></Input>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import Utils from '../../utils'
import API from "../../api";
export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", 'dev');
  },
  mounted() {
    this.getMenuList();
    this.parentMenuList();
  },
  data() {
    return {
      columns: [
        {
          title: 'ID',
          align: 'center',
          width: 100,
          key: 'menuId',
          sortable: true
        },
        {
          title: '父级菜单',
          align: 'center',
          width: 150,
          key: 'parentMenu'
        },
        {
          title: '名称',
          align: 'center',
          width: 150,
          key: 'name'
        },
        {
          title: '类型',
          align: 'center',
          width: 150,
          render: (h, param) => {
            return h('Tag', {
              props: {
                color: param.row.type == 'view' ? 'blue' : 'yellow'
              }
            }, param.row.type)
          }
        },
        {
          title: '关键词',
          align: 'center',
          width: 200,
          key: 'keyword'
        },
        {
          title: '链接',
          align: 'center',
          width: 200,
          render: (h, param)=>{
            return h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              on: {
                click: () => {
                  this.$Modal.info({
                    title: '查看链接',
                    content: param.row.url
                  })
                }
              }
            }, '查看链接')
          }
        },
        {
          title: '创建时间',
          align: 'center',
          width: 200,
          key: 'createTime'
        },
        {
          title: '操作',
          align: 'center',
          width: 250,
          render: (h, param) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.editMenuBtn(param.row)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  marginLeft: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '消息提醒',
                      content: `确定删除 ${param.row.menuId}-${param.row.name} 吗？`,
                      onOk: ()=>{
                        this.delMenuItem(param.row.menuId)
                      }
                    })
                  }
                }
              }, '删除'),
            ])
          }
        },
      ],
      menuList: [],
      modalConfig: {
        title: '新增菜单',
        display: false,
        data: {
          type: 'view',
          parentId: 0,
          menuId: null,
          keyword: null,
          name: null,
          isExtUrl: 1,
          url: null,
          appId: null,
          pagePath: null
        },
        defaultData: {
          type: 'view',
          parentId: 0,
          menuId: null,
          keyword: '',
          name: '',
          isExtUrl: 1,
          url: null,
          appId: null,
          pagePath: null
        },
      }
    }
  },
  methods: {
    addMenuBtn() {
      this.modalConfig.title = '新增菜单';
      this.modalConfig.display = true;
      this.modalConfig.data = Object.assign({}, this.modalConfig.defaultData)
    },
    editMenuBtn(obj) {
      this.modalConfig.data = Object.assign({}, this.modalConfig.defaultData, obj)
      this.modalConfig.title = '编辑菜单';
      this.modalConfig.display = true
    },
    modalBtn() {
      this.$refs.modal.buttonLoading = false
      let params = Object.assign({}, this.modalConfig.data)
      if((params.name).trim() === ''){
        this.$Notice.error({
          title: '菜单名称不能为空'
        })
        return
      }
      if(params.type === 'view') {
        if(!(/(http|https):\/\/([\w-]+\.)+[\w-]+(\/[\w- \.\/?%&=]*)?/.test(params.url))){
          this.$Notice.error({
            title: '链接格式有误'
          })
          return
        }
      }
      if(params.type === 'click') {
        if((params.keyword).trim() === ''){
          this.$Notice.error({
            title: '关键字不能为空'
          })
          return
        }
      }
      if(params.type === 'miniprogram') {
        if((params.appId).trim() === ''){
          this.$Notice.error({
            title: 'appId不能为空'
          })
          return
        }
      }
      if(params.type === 'miniprogram') {
        if((params.pagePath).trim() === ''){
          this.$Notice.error({
            title: '页面路径不能为空'
          })
          return
        }
      }
      if(params.type === 'miniprogram') {
        if(!(/(http|https):\/\/([\w-]+\.)+[\w-]+(\/[\w- \.\/?%&=]*)?/.test(params.url))){
          this.$Notice.error({
            title: '链接格式有误'
          })
          return
        }
      }
      this.modalConfig.display = false
      params.menuId ? this.editMenu(params) : this.addMenu(params)
    },
    async generateMenu() {
      let resp = (await API.omsAPI[this.env].php.generateMenu()).data;
      this.$Notice[resp.retcode==1? 'success' : 'error']({
        title: resp.retmsg
      })
    },
    async parentMenuList() {
      let resp = (await API.omsAPI[this.env].php.parentMenuList()).data;
      this.parentMenuList = resp.retdata;
    },
    async getMenuList() {
      let resp = (await API.omsAPI[this.env].php.getMenuList()).data;
      if(resp.retcode != 0){
        this.$Notice.error({
          title: '获取菜单列表失败',
          desc: resp.retmsg
        });
        return
      }
      this.menuList = resp.retdata;
    },
    async addMenu(params) {
      let resp = (await API.omsAPI[this.env].php.addMenuItem(params)).data
      this.$Notice[resp.retcode==1?'success':'error']({
        title: resp.retmsg
      })
      resp.retcode==1 && this.getMenuList()
    },
    async editMenu(params) {
      let resp = (await API.omsAPI[this.env].php.editMenuItem(params)).data
      this.$Notice[resp.retcode==1?'success':'error']({
        title: resp.retmsg
      })
      resp.retcode==1 && this.getMenuList()
    },
    async delMenuItem(menuId) {
      let resp = (await API.omsAPI[this.env].php.delMenuItem({
        menuId: menuId
      })).data;
      this.$Notice[resp.retcode==1?'success':'error']({
        title: resp.retmsg
      })
      resp.retcode==1 && this.getMenuList()
    }
  }
}
</script>

<style lang="scss" scoped>
.tips{
  color: red;
}
</style>




// WEBPACK FOOTER //
// src/pages/wechat/menu-manage.vue